import type { $ } from "../../../dom";
import { ButtonGroupInput, type ButtonGroupInputOptions } from "../base";
import { SimpleButtonInput } from "./simple-button-input";

export type SimpleButtonGroupInputOptions = ButtonGroupInputOptions<string> & {
  instantiateInputs?: ($: $) => SimpleButtonInput[];
};

export class SimpleButtonGroupInput extends ButtonGroupInput<string | null> {
  public inputs: SimpleButtonInput[] = [];

  protected readonly inputFactory: () => SimpleButtonInput[];

  constructor($root: $, options: SimpleButtonGroupInputOptions = {}) {
    const { instantiateInputs, ...superOptions } = options;

    super($root, superOptions);

    this.inputFactory = instantiateInputs
      ? () => instantiateInputs(this.$root)
      : () =>
          this.$root.children.map(
            (element) => new SimpleButtonInput(this.$root.make(element)),
          );

    this.bindInputs();
  }
}
